'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendErrorToSentryAndNewRelic = sendErrorToSentryAndNewRelic;
function sendErrorToNewRelicHelper(error, message, extras) {
  // New Relic is only on the window if it is enabled (most of the time, only in production)
  if (window.newrelic && window.newrelic.noticeError) {
    // New Relic uses the same API to send errors or strings
    if (error instanceof Error) {
      window.newrelic.noticeError(error);
    } else if (message != null && message !== '') {
      window.newrelic.noticeError(message);
    } else {
      window.newrelic.noticeError(new Error("sendErrorToNewRelicHelper() called without any error or message"));
    }
  }
}

function sendErrorToSentryHelper(error, message, extras, tags) {
  // Assume the app has correctly set up Raven to send to Sentry (by default Raven is available but
  // disabled for local development)
  if (window.Raven && window.Raven.captureException && window.Raven.captureMessage) {
    var moreInfo = { extra: extras, tags: tags };

    if (error instanceof Error) {
      window.Raven.captureException(error, moreInfo);
    } else if (message != null && message !== '') {
      window.Raven.captureMessage(message, moreInfo);
    } else {
      window.Raven.captureMessage('sendErrorToSentryHelper() called without any error or message');
    }
  }
}

function getMessageStringAndExtrasFromError(error, _ref) {
  var messagePrefix = _ref.messagePrefix,
      messageSuffix = _ref.messageSuffix,
      tags = _ref.tags;

  var result = {
    message: undefined,
    extras: {}
  };

  if (messagePrefix != null) {
    messagePrefix = messagePrefix + ' ';
  } else {
    messagePrefix = '';
  }

  if (messageSuffix != null) {
    messageSuffix = ' ' + messageSuffix;
  } else {
    messageSuffix = '';
  }

  if (tags != null) {
    result.tags = tags;
  }

  if (error != null && typeof error.message === 'string') {
    result.message = '' + messagePrefix + error.message + messageSuffix;
    error.message = result.message; // Also modify the actual error message
  } else if (typeof error === 'string') {
    result.message = '' + messagePrefix + error + messageSuffix;
  } else {
    result.message = '' + messagePrefix + messageSuffix;
  }

  // Pass along extra info than just a message to Raven (not supported by New Relic)
  if (error != null) {
    try {
      result.extras.stringifiedMessage = JSON.stringify(error);
    } catch (jsonError) {
      result.extras.toStringedMessage = String(error);
    }
  }

  return result;
}

function sendErrorToSentryAndNewRelic(error) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (error != null) {
    var _getMessageStringAndE = getMessageStringAndExtrasFromError(error, options),
        message = _getMessageStringAndE.message,
        extras = _getMessageStringAndE.extras,
        tags = _getMessageStringAndE.tags;

    sendErrorToSentryHelper(error, message, extras, tags);
    sendErrorToNewRelicHelper(error, message, extras);
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-5.22/js/util/sendError.js
// module id = 243
// module chunks = 0